import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar"
import { Badge } from "../ui/badge"
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card"

const commercialLeads = [
  {
    name: "Lead #4521",
    email: "mario.rossi@email.com",
    amount: "€ 35.000",
    status: "Nuovo",
    statusVariant: "default",
    date: "Oggi, 09:15",
  },
  {
    name: "Lead #4518",
    email: "azienda.beta@email.com",
    amount: "€ 120.000",
    status: "In trattativa",
    statusVariant: "secondary",
    date: "Ieri, 16:40",
  },
  {
    name: "Lead #4510",
    email: "cliente.gamma@email.com",
    amount: "€ 18.500",
    status: "Proposta inviata",
    statusVariant: "warning",
    date: "Ieri, 11:20",
  },
]

const legalDeadlines = [
  {
    name: "Pratica #3201",
    email: "Tribunale Napoli",
    amount: "Udienza",
    status: "Oggi",
    statusVariant: "destructive",
    date: "10:30",
  },
  {
    name: "Pratica #3198",
    email: "Tribunale Milano",
    amount: "Memoria",
    status: "Domani",
    statusVariant: "warning",
    date: "09:00",
  },
  {
    name: "Pratica #3189",
    email: "Tribunale Roma",
    amount: "Termine per deposito",
    status: "Tra 3 giorni",
    statusVariant: "secondary",
    date: "12:00",
  },
]

const adminPayments = [
  {
    name: "Fattura #2024-118",
    email: "Studio Rossi",
    amount: "€ 4.250",
    status: "Incassata",
    statusVariant: "success",
    date: "Oggi, 08:10",
  },
  {
    name: "Fattura #2024-115",
    email: "Cliente Beta",
    amount: "€ 9.800",
    status: "Insoluta",
    statusVariant: "destructive",
    date: "Ieri, 18:45",
  },
  {
    name: "Fattura #2024-110",
    email: "Cliente Gamma",
    amount: "€ 2.300",
    status: "In scadenza",
    statusVariant: "warning",
    date: "Tra 2 giorni",
  },
]

const coordinationActivity = [
  {
    name: "Commerciale",
    email: "Deal aperti: 24",
    amount: "Carico medio: 6",
    status: "Regolare",
    statusVariant: "success",
    date: "Oggi",
  },
  {
    name: "Legale",
    email: "Pratiche urgenti: 7",
    amount: "Team coinvolti: 3",
    status: "Attenzione",
    statusVariant: "warning",
    date: "Ultime 24h",
  },
  {
    name: "Amministrazione",
    email: "Pagamenti da riconciliare: 12",
    amount: "Fatture mese: 86",
    status: "In corso",
    statusVariant: "secondary",
    date: "Ultimi 7 giorni",
  },
]

const hrPeople = [
  {
    name: "Nuovo Assunto #ID-204",
    email: "junior.account@azienda.com",
    amount: "Onboarding - 1° settimana",
    status: "Onboarding",
    statusVariant: "warning",
    date: "Oggi, 09:00",
  },
  {
    name: "Campagna Recruiting Sales",
    email: "candidature@azienda.com",
    amount: "Candidature ricevute: 42",
    status: "Attiva",
    statusVariant: "secondary",
    date: "Ultimi 7 giorni",
  },
  {
    name: "Corso Soft Skills",
    email: "formazione@azienda.com",
    amount: "Partecipanti: 18",
    status: "Programmato",
    statusVariant: "default",
    date: "Tra 3 giorni",
  },
]

const defaultClients = [
  {
    name: "Giuseppe Verdi",
    email: "giuseppe.verdi@email.com",
    amount: "€ 45.000",
    status: "In Analisi",
    statusVariant: "warning",
    date: "Oggi, 10:30",
  },
  {
    name: "Maria Bianchi",
    email: "m.bianchi@email.com",
    amount: "€ 12.500",
    status: "Completata",
    statusVariant: "success",
    date: "Ieri, 15:45",
  },
  {
    name: "Antonio Rossi",
    email: "antonio.rossi@email.com",
    amount: "€ 8.200",
    status: "Nuovo",
    statusVariant: "default",
    date: "Ieri, 09:15",
  },
]

const leadItems = [
  {
    name: "Lead Web #L-785",
    email: "modulo-web@azienda.com",
    amount: "Fonte: Web",
    status: "Nuovo",
    statusVariant: "default",
    date: "Oggi, 10:05",
  },
  {
    name: "Lead Campagna #C-219",
    email: "ads@campagna.com",
    amount: "Fonte: Campagne",
    status: "Qualificato",
    statusVariant: "success",
    date: "Ieri, 16:20",
  },
  {
    name: "Lead Referral #R-102",
    email: "segnalazione@partner.it",
    amount: "Fonte: Referral",
    status: "In contatto",
    statusVariant: "secondary",
    date: "Ieri, 11:45",
  },
]

export function RecentClients({ variant = "default" }) {
  const normalizedVariant = variant.toLowerCase()

  let title = "Clienti Recenti"
  let description = "Ultimi contatti e stato pratiche"
  let items = defaultClients

  if (normalizedVariant === "commerciale") {
    title = "Lead Recenti"
    description = "Nuove opportunità entrate in pipeline"
    items = commercialLeads
  } else if (normalizedVariant === "lead") {
    title = "Lead Recenti"
    description = "Ultimi lead per fonte e stato"
    items = leadItems
  } else if (normalizedVariant === "legale") {
    title = "Scadenze Imminenti"
    description = "Udienze e termini da gestire a breve"
    items = legalDeadlines
  } else if (normalizedVariant === "amministrazione") {
    title = "Pagamenti Recenti"
    description = "Incassi registrati e insoluti"
    items = adminPayments
  } else if (normalizedVariant === "coordinamento") {
    title = "Stato Dipartimenti"
    description = "Carico di lavoro per ogni area"
    items = coordinationActivity
  } else if (normalizedVariant === "risorse umane" || normalizedVariant === "hr") {
    title = "Persone & Recruiting"
    description = "Onboarding, ricerche aperte e formazione"
    items = hrPeople
  }

  return (
    <Card className="border-none shadow-sm">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          {items.map((item, index) => (
            <div key={index} className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <Avatar className="h-10 w-10">
                  <AvatarImage src={`https://api.dicebear.com/7.x/avataaars/svg?seed=${index}`} alt={item.name} />
                  <AvatarFallback>{item.name.substring(0, 2).toUpperCase()}</AvatarFallback>
                </Avatar>
                <div>
                  <p className="text-sm font-medium leading-none">{item.name}</p>
                  <p className="text-xs text-muted-foreground mt-1">{item.email}</p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="text-right hidden sm:block">
                  <p className="text-sm font-medium">{item.amount}</p>
                  <p className="text-xs text-muted-foreground">{item.date}</p>
                </div>
                <Badge variant={item.statusVariant}>{item.status}</Badge>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}
